import React, { Component } from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import swal from 'sweetalert';
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from '@material-ui/core/styles';
import { geocodeByPlaceId, } from 'react-places-autocomplete';
import moment from 'moment';
import { Avatar, Select, MenuItem, Modal,Input,Button,IconButton } from '@material-ui/core';
import EditProfile from './editProfile';
import {history} from '../../../store';
import axiosI from '../../../Service/service';
import CardForm from './editPaymentForm';
import img from '../../../images/img1.jpg';
import {routeName} from '../../../Service/env';
import { enableLoading, disableLoading, getAccountDetailAction,updateProfileBio } from '../../../Actions/myAccountAction';
import { GetBusinessProfile } from '../../../Actions/businessProfineAction';
import { disableLoader, enableLoader } from '../../../Actions/index';
import converter from '../../../Helper/convertFile';
import './myAccount.css';
import { cancelPlanAction, getTransactionDetailAction, editPaymentDetails } from '../../../Actions/paymentAction';
import Alert from '../../../Helper/SimpleAlert/alert';
import logo from '../../../images/logo.png';
import axios from 'axios';
import * as constants from '../../../Constants';

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  textField: {
    fontSize: '15px',
    marginTop: '5px',
  },
  page: {
    fontSize: '12px'
  },
  date: {
    width: '10%'
  },
  modal: {
    textAlign: 'center'
  },
  label: {
    fontSize: '1.5em',
    color: '#777777',
    fontWeight: 600
  },
  editImage: {
    position: 'absolute',
    width: '450px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: theme.spacing.unit * 4,
    padding: '10px 0px 0px 5px',
    top: '25%',
    left: '37%',
    borderRadius: '20px',
    height: '340px',
    isSearching: '',
    outline: 'none',
    border: 'none',
  },
  select:{
    width:300,
    visibility:'hidden',
    fontSize:20,
  },
  MenuItem:{
    fontSize: 20
  }
});

class AccountDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      smallImagesData: {},
      smallImage: '',
      smallImageProfile: [],
      smallImageChange: false,
      smallImagePreviewFile: '',
      largeImagesData: {},
      largeImage: '',
      largeImageProfile: [],
      largeImageChange: false,
      largeImagePreviewFile: '',
      open: false,
      editImage: false,
      editCoverImage: false,
      showAlert:false,
      coverImageURL:"",
      profileImageURL:"",
      Msg:'',
      isLoading:false,
      openPaymentModal:false,
      setEdit:false,
      openProfileChangePopUp:false,
      openCoverChangePopUp:false,
      address:{},
      isplanCancel:false,
      updateState:false
    }
  }
  displayPhoneNo=(phoneno)=>{
    let no=phoneno.toString();
    return no.substring(0,3) + "-" + no.substring(3,6)+"-"+no.substring(6,no.length);
  }

  submitBioChanges=()=>{
      this.setState({setEdit:false},()=>{
        this.props.updateProfileBio(this.props.user.BusinessUser.AppUserID,this.state.Bio);
      })
  }

  editBio=()=>{
      this.setState({setEdit:true,Bio:this.props.user.AppUser.Bio})
  }

  componentWillReceiveProps(nextProps){
      if(nextProps.user.AppUser)
      {
        if(nextProps.user.AppUser.Bio)
          this.setState({ Bio: nextProps.user.AppUser.Bio })
      }
  }

  componentDidMount() {
    let { user }=this.props;
    let {address} = this.state;
    address={};
    geocodeByPlaceId(user.BusinessUser.PlaceID)
      .then((data) => {
        let {address_components} = data[0]
        address_components.forEach((d) => {
          if (d.types[0] === 'street_number')
            address['street_no'] = d.short_name
          if (d.types[0] === 'route' || d.types[0]==="political")
            address['route'] = d.short_name
          if(d.types[0] === 'subpremise' )
            address['subpremise']=d.short_name;
          if (d.types[0] === 'locality')
            address['locality'] = d.short_name
          if (d.types[0] === 'administrative_area_level_1')
            address['administrative_area_level_1'] = d.short_name
          if (d.types[0] === 'postal_code')
            address['postal_code'] = d.short_name
          if(d.types[0]==='country')
            address['country']=d.short_name
          this.setState({address});
        })

          //console.log("state address----",this.state.address)
      })
    this.props.getAccountDetailAction(user.BusinessUser.BusinessId);
    let profileImageURL
    let coverImageURL
    if(user.AppUser.ProfileImage && user.AppUser.ProfileImage) {
      this.setState({openProfileChangePopUp:true})
      profileImageURL = `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${this.props.user.AppUser.ProfileImage}`;
    }
    else {
      profileImageURL = null;
    }
    if(!user.AppUser.CoverImage) {
      let value = Math.floor(Math.random() * 4) + 1;
      coverImageURL=require(`../../../images/BusinessProfile/${value}.jpg`);
    }
    else {
      this.setState({openCoverChangePopUp:true})
      coverImageURL = `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserCoverImages/OriginalUserCoverImage/${user.AppUser.CoverImage}`;
    }
    this.setState({coverImageURL, profileImageURL});
  }

  handleOpen = () => {
    this.setState({open: !this.state.open})
  };

  cancelPlan=(e)=>{
    if(e.target.id==="Reactive"){
        history.push({pathname:`/${routeName}/Payment`,state:{withTrial:false}});
    }else{
      swal({
        title: "Are you sure?",
        text: "Once canceled, you will have to Reactivate plan!",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            this.setState({
              isLoading:true
            });
            this.props.cancelPlanAction({
              BusinessID:this.props.user.BusinessUser.BusinessId,
              PaypalProfileID:this.props.user.BusinessUser.PaypalProfileID,
              Reason:"Cancel From Business Panel"
            }).then((data)=>{
              if(data.ResponseCode) {
                this.showAlert(true,'Plan Cancelled Successfully.');
                this.setState({
                  isLoading:false,
                  isplanCancel:!this.state.isplanCancel,
                });
                  swal("Poof! Your plan has been canceled!", {
                      icon: "success",
                  });
                this.props.onUpdate();
              }
              else {
                this.setState({ isLoading: false });
                  swal('Something went wrong while canceling plan,Please try again after some time.   ');

              }
            }).catch((err)=>{
              console.log(err);
            });
          } else {
                swal("Your plan is safe!");
          }
        });

    }
  };

  GenratePaymentPdf=(businessName,address,planName,data)=>{
    let mywindow = window.open('', 'PRINT', 'height=800,width=1200');
    mywindow.document.write('<html><body><div style="width: 100%;text-align: center">');
    mywindow.document.write("<img src='" + logo + "'  width='100px' height='100px'/></div>")
    mywindow.document.write('<div style="width:100%; margin-top: 30px; display:inline-flex"><div style="display: block;width: 70%;"><div><table><tr><td style="vertical-align: baseline;">')
    mywindow.document.write('From:')
    mywindow.document.write('</td><td>')
    mywindow.document.write('Ubme,Inc.<br/>')
    mywindow.document.write('<br/></td></tr></table></div><div style=""><table><tr><td>')
    mywindow.document.write('Bill to:');
    mywindow.document.write('</td><td>');
    mywindow.document.write(`${businessName}`);
    mywindow.document.write('</td></tr><tr><td></td><td>');
    mywindow.document.write(`${(address[0]!==undefined) ? address[0]:''} ${(address[1]!==undefined) ? ', ' + address[1]:''}<br/>${(address[2]!==undefined) ? address[2]:''} ${(address[3]!==undefined) ? ', ' + address[3]:''}<br/>${(address[4]!==undefined) ? address[4]:''} ${(address[5]!==undefined) ? ', ' + address[5]:''}<br/>${(address[6]!==undefined) ? address[6]:''}`);
    mywindow.document.write('</td></tr></table></div></div><div style="width: 30%;"><table><tr><td colspan="2" style="width:100%; text-align: center; text-transform: uppercase; font-weight: bold;  -webkit-print-color-adjust: exact; background-color: #ddd;">')
    mywindow.document.write('Invoice');
    mywindow.document.write('</td></tr><tr style="height:12px"></tr><tr><td style="width=40%">');
    mywindow.document.write('Invoice#');
    mywindow.document.write('</td><td style="padding-left: 5px; width: 60%;">');
    mywindow.document.write(`${data.TransactionDetails.TransctionID}`);
    mywindow.document.write('</td></tr><tr><td style="width=40%">');
    mywindow.document.write('Date');
    mywindow.document.write('</td><td style="padding-left: 5px; width: 60%">');
    mywindow.document.write(`${moment(moment(data.TransactionDetails.TransactionDate).utc().toDate()).local().format('MMM DD, YYYY')}`);
    mywindow.document.write('</td></tr><tr><td>');
    mywindow.document.write('Amount');
    mywindow.document.write('</td><td style="padding-left: 5px;">');
    mywindow.document.write(`$${data.TransactionDetails.Amount}`);
    mywindow.document.write('</td></tr></table></div></div><br/>');
    mywindow.document.write('<div style="width:100%;display:block;"><table style="margin: 30px 0; border: 2px solid #000; border-collapse: collapse; width: 100%;"><tr style="width: 85%; -webkit-print-color-adjust: exact;background: #ddd;"><td style="border: 2px solid #000; border-collapse: collapse; padding: 5px; font-weight: bolder;">')
    mywindow.document.write('PLAN');
    mywindow.document.write('</td><td style="font-weight:bolder;text-align: right; border: 2px solid #000; border-collapse: collapse; padding: 5px;">')
    mywindow.document.write('AMOUNT');
    mywindow.document.write('</td></tr><tr style="width: 15%;"><td style="border: 2px solid #000; border-collapse: collapse; padding: 5px;">')
    mywindow.document.write(`${planName}`)
    mywindow.document.write('</td><td style="text-align:right;border:2px solid #000; border-collapse: collapse; padding: 5px;">')
    mywindow.document.write(`$${data.TransactionDetails.Amount}`);
    mywindow.document.write('</td></tr><tr><td style="text-align:right;border:2px solid #000; border-collapse: collapse; padding: 5px;">')
    mywindow.document.write('Total Amount')
    mywindow.document.write('</td><td style="text-align: right;border:2px solid #000; border-collapse: collapse; padding: 5px;">')
    mywindow.document.write(`$${data.TransactionDetails.Amount}`);
    mywindow.document.write('</td></tr></table></div>');
    mywindow.document.write('<div style="width:100%;text-align:right;">');
    mywindow.document.write('Invoice created by UBMe, Inc.');
    mywindow.document.write('</div>');
    mywindow.document.write('</body></html>');
    mywindow.document.close();
    setTimeout(()=>{
      mywindow.print();
      mywindow.close();
    },10);
  };

  handleChangeRoundImg = (e) => {
    let {smallImagesData} = this.state;
    let {name, value} = e.target;
    const {smallImageProfile} = this.state;
    this.props.enableLoading();
    if (name === "smallImage") {
      smallImageProfile[name] = e.target.files[0];
    }
    else {
      smallImageProfile[name] = value;
    }
    this.setState({smallImageProfile});
    let userId = this.props.user.AppUser.UserId;
    let lat = this.props.user.AppUser.Latitude;
    let lng = this.props.user.AppUser.Longitude;
    converter.toBase64(smallImageProfile.smallImage).then((dt) => {
      dt = dt.substring(dt.indexOf(',') + 1);
      smallImagesData[name] = dt;
      let data = {
        Latitude: lat,
        Longitude: lng,
        ProfileImage: dt,
        UserId: userId.toString()
      };
      axiosI.post(constants.API.uploadUserProfileImageApi,data,{
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        if (response.data.results.ResponseCode) {
          this.setState({
            profileImageURL:response.data.results.ImageUrl,
            openProfileChangePopUp:true
          })
          this.showAlert(true,'Profile Image Updated successfully.')
        }
        else {
          alert('unable to change image.');
        }
        this.props.disableLoading();
      }).catch((err) => {
        this.props.disableLoading();
        console.log(err);
      });
    });
  };

  handleRoundImg = (e) => {
    if(e.target.files[0].type==='image/png' ||e.target.files[0].type==='image/jpg' ||e.target.files[0].type==='image/jpeg'){
      if (e.target.files.length) {
        this.setState({
          smallImageChange: true
        });
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
          this.setState({
            smallImage: file,
            smallImagePreviewFile: reader.result
          });
        };
        reader.readAsDataURL(file);
        this.handleChangeRoundImg(e);
      }
    }
    else {
      swal("Invalid file Type!", "You choosed wrong file!", "error");
    }

  };

  handleChange = (e) =>  {
    let {largeImagesData} = this.state;
    let {name, value} = e.target;
    const {largeImageProfile} = this.state;
    if(e.target.files[0].type==='image/png' ||e.target.files[0].type==='image/jpg' ||e.target.files[0].type==='image/jpeg') {
      this.props.enableLoading();
      if (name === "largeImage") {
        largeImageProfile[name] = e.target.files[0];
      }
      else {
        largeImageProfile[name] = value;
      }
      this.setState({largeImageProfile});
      let userId = this.props.user.AppUser.UserId;
      let lat = this.props.user.AppUser.Latitude;
      let lng = this.props.user.AppUser.Longitude;
      converter.toBase64(largeImageProfile.largeImage).then((dt) => {
        dt = dt.substring(dt.indexOf(',') + 1);
        largeImagesData[name] = dt;
        let data = {
          Latitude: lat,
          Longitude: lng,
          CoverImage: dt,
          UserId: userId.toString()
        };
        axiosI.post(constants.API.uploadUserCoverImageApi, data, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then((response) => {
          if (response.data.results.ResponseCode) {
            this.setState({
              coverImageURL: response.data.results.ImageUrl,
              openCoverChangePopUp:true
            })
            this.showAlert(true,'Cover Image Updated successfully.')
          }
          else {
            alert('unable to change image.');
          }
          this.props.disableLoading();
        }).catch((err) => {
          this.props.disableLoading();
          console.log(err);
        });
      });
    }
    else {
      swal("Invalid file Type!", "You choosed wrong file!", "error");
    }
  };

  handleImg = (e) => {
    if (e.target.files.length) {
      this.setState({
        largeImageChange: true
      });
      let reader = new FileReader();
      let file = e.target.files[0];
      reader.onloadend = () => {
        this.setState({
          largeImage: file,
          largeImagePreviewFile: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  showEditImage = (e) => {
    // console.log(e.target.id);
    // if(e.target.id==='profileImage')
    //   this.setState({editImage:!this.state.editImage});
    // else
    //   this.setState({editCoverImage:!this.state.editCoverImage});
    // let {editCoverImage, editImage} = this.state;
    // if(editCoverImage) {
    //   editCoverImage = false;
    // }
    // editImage = !editImage;
    // this.setState({ editImage, editCoverImage });
  };

  removeImage = () => {
    let {editCoverImage} = this.state;
    let {user} = this.props;
    this.props.enableLoading();
    if(editCoverImage) {
      let data = {
        ProfileImage: user.AppUser.ProfileImage,
        CoverImages: "",
        AppUserID: user.AppUser.UserId
      };
      axiosI.post(constants.API.removeUserProfileCoverImageApi, data,
        {
          headers:{
            "Authorization":localStorage.getItem('token')
          }
        }).then((response) => {
        if(response.data.results.ResponseCode) {
          let editImage
          let coverImageURL
          editImage = false;
          let openCoverChangePopUp=false;
          this.setState({ editImage,openCoverChangePopUp});
          let value = Math.floor(Math.random() * 4) + 1;
          coverImageURL=require(`../../../images/BusinessProfile/${value}.jpg`);
          this.setState({ coverImageURL });
        }
        else {
          alert(response.data.results.Message);
        }
        this.props.disableLoading();
      }).catch((err) => {
        console.log(err);
        this.props.disableLoading();
      });
    }
    else {
      let data = {
        ProfileImage: "",
        CoverImages: user.AppUser.CoverImage,
        AppUserID: user.AppUser.UserId
      };
      axiosI.post(constants.API.removeUserProfileCoverImageApi, data,
        {
          headers:{
            "Authorization":localStorage.getItem('token')
          }
        }).then((response) => {
        if(response.data.results.ResponseCode) {
          this.setState({
            profileImageURL:null,
            openProfileChangePopUp:false

          });
          this.props.disableLoading();
        }
        else {
          alert(response.data.results.Message);
        }
      }).catch((err) => {
        this.props.disableLoading();
        console.log(err);
      });
    }
    this.showEditImage();
  };

  changeCoverImage = (e) => {
    // if (this.state.openCoverChangePopUp) {
    if(e==='profileImage') {
        this.setState({editImage: !this.state.editCoverImage});
    }
    else {
        this.setState({editCoverImage: !this.state.editCoverImage});
    }

    // }
  };

  showAlert = (flag,msg) => {
    if(msg) {
      this.setState({
        showAlert: flag,
        Msg:msg
      });
    }
    else {
      this.setState({
        showAlert: false,
        Msg:""
      });
    }
  };

  showInput = (e) => {
    if(e.target.value === 'removeProfilePhoto' || e.target.value === 'removeCoverPhoto' ) {
      this.removeImage();
    }
    else {
      let {editCoverImage} = this.state;
      if (editCoverImage) {
        if(e.target.value==='changeProfilePhoto')
          this.setState({openProfileChangePopUp:true})
        else
          this.setState({openCoverChangePopUp:true})
        this.refs.img.click();
      }
      else {
        this.refs.imgs.click();
      }
    }
  };

  handleEditPayment=()=>{
    this.setState({openPaymentModal:!this.state.openPaymentModal})
  }

  getTransactionData=(planName,transactionId)=>{
    let {user,accountDetail} = this.props;
    this.props.getTransactionDetailAction(transactionId,(accountDetail.PaymentMethod==='PAYPALBUTTON')?'PAYPAL':accountDetail.PaymentMethod).then((data)=>{
      if(data.ResponseCode)
        this.GenratePaymentPdf(user.BusinessUser.BusinessName,user.BusinessUser.Address.split(","),planName,data);
    });
  };

  handlePaymentToggle=()=>{
    this.setState({openPaymentModal:!this.state.openPaymentModal})
  }

  updateState=()=> {
    this.setState({updateState: true});

  }

  getModalStyle=()=>{
    return {
      borderRadius: '3px',
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
    };
  }

  alertCallback=()=>{
    this.setState({showAlert:!this.state.showAlert})
  }

  handleBioChange=(e)=>{
    this.setState({Bio:e.target.value});
  }

  handleProfileClose=()=>{
    this.setState({editImage:!this.state.editImage})
  }

  handleCoverClose=()=>{
    this.setState({editCoverImage:!this.state.editCoverImage})
  }

  cancelBioChange=()=>{
    this.setState({setEdit:false,Bio:this.props.user.AppUser.Bio})
  }

  handleClose=()=>{
    this.handlePaymentToggle();
  }

  render() {

    let {classes, user, accountDetail} = this.props;
    let {editImage,editCoverImage, open, showAlert, coverImageURL, profileImageURL,openProfileChangePopUp,openCoverChangePopUp,address} = this.state;
    return (
      <React.Fragment>
        {
          open && <EditProfile
            user={this.props.user}
            handleOpen={this.handleOpen}
            showAlert={this.showAlert}
            onUpdate={this.updateState}
          />
        }
        <Modal
          open={this.state.openPaymentModal}
          onClose={this.handlePaymentToggle}
        >
          <div className="payment-information" style={this.getModalStyle()}>
           <div style={{display:"flex"}}>
             <div><CardForm user={this.props.user} onCancel={this.handleClose}/></div>
             <div><IconButton color="inherit" onClick={this.handleClose} aria-label="Close" className="close-btn-edit-modal" >
               <CloseIcon />
             </IconButton></div>
          </div>
          </div>
        </Modal>
        <Alert
          showSuccess={showAlert}
          showError={false}
          Msg={this.state.Msg} //"Password has been updated."
          onShow={this.showAlert}
          onClose={this.showAlert}
        />


        <ul className='custom-menu'>
          <li data-action="first">First thing</li>
          <li data-action="second">Second thing</li>
          <li data-action="third">Third thing</li>
        </ul>
        <div className="account-box">

            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="col-md-12">
                <div className="image-gulp">
                  <div>
                    <div className="col-lg-10 col-md-4 col-sm-6 col-xs-12">
                      <div className="hovereffect">
                        <img className="img-responsive cover-image"
                             src={coverImageURL}
                             alt=""
                        />
                        <div className="overlay">
                          <p>
                            <a>
                              <input type="file" ref="img"
                                     id="fileLoader"
                                     name="largeImage"
                                     title="Load File"
                                     onChange={(e) => {
                                       this.handleChange(e);
                                       this.handleImg(e);
                                     }} style={{display: 'none'}}/>
                              <div onClick={()=>this.changeCoverImage("coverImage")}>
                                <i className="glyphicon glyphicon-camera"
                                   style={{fontSize: '40px'}}/>
                              </div>
                            </a>
                          </p>
                        </div>
                        <div className="round-img">
                          <Avatar className="avatar-img">
                            {
                              profileImageURL ?
                                <img
                                  src={profileImageURL}
                                  height={70} width={70}
                                />
                                :
                                <img
                                  src={require(`../../../images/Alphabets/${this.props.user.AppUser.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)}
                                  height={70} width={70}
                                />
                            }
                          </Avatar>
                          <div className="overlay">
                            <p>
                              <a>
                                <input type="file" ref="imgs"
                                       id="fileLoader"
                                       name="smallImage"
                                       title="Load File"
                                       onChange={(e) => {
                                         this.handleRoundImg(e);
                                       }} style={{display: 'none'}}/>
                                <div
                                  onClick={()=>this.changeCoverImage("profileImage")}>
                                  <i className="glyphicon glyphicon-camera"
                                     style={{fontSize: '40px'}}/>
                                </div>
                                {(editImage) && <Select open={editImage} onClose={this.handleProfileClose} onChange={this.showInput} className={classes.select}>
                                  <MenuItem className={classes.MenuItem} value="changeProfilePhoto">Change Profile Photo</MenuItem>
                                  {openProfileChangePopUp && <MenuItem className={classes.MenuItem} value="removeProfilePhoto">Remove Profile Photo</MenuItem>}
                                </Select>}
                              </a>
                            </p>
                            {(editCoverImage) && <Select open={editCoverImage} onClose={this.handleCoverClose} onChange={this.showInput} className={classes.select}>
                              <MenuItem className={classes.MenuItem} value="changeCoverPhoto">Change Cover Photo</MenuItem>
                              {openCoverChangePopUp && <MenuItem className={classes.MenuItem} value="removeCoverPhoto">Remove Cover Photo</MenuItem>}
                            </Select>}
                          </div>
                        </div>
                      </div>
                      {this.state.setEdit
                        ?
                        <div>
                          <Input
                            disableUnderline={true}
                            className='bio-text textboxControl payment-input'
                            type={'text'}
                            placeholder={'i.e. John Deo'}
                            name={'Fullname'}
                            value={this.state.Bio}
                            onChange={this.handleBioChange}
                          />
                          <Button className="bio-cancel-btn" variant={'contained'} color={'primary'} onClick={this.cancelBioChange}>Cancel</Button>
                          <Button className="bio-edit-btn" variant={'contained'} color={'primary'} onClick={this.submitBioChanges}>Save</Button>
                        </div>
                        :
                        <div className="bio-text" onClick={this.editBio}>{this.state.Bio}
                        </div>}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-xs-12 col-sm-12 add-text">
                  <div>
                    <h1>{user.AppUser.FirstName}</h1>
                    <a>{user.AppUser.Email}</a>
                    <p>{
                        <div>
                          <p>
                            {address.street_no && <span>
                           {` ${address.street_no && address.street_no} ` }
                         </span>}
                            {address.route && <span>
                           {address.route && address.route}
                         </span>}
                            {address.subpremise && <span>{`, ${address.subpremise}`}</span>}
                          </p>
                          <p>{address.locality && <span>{`${address.locality && address.locality},`}</span>}
                            {address.administrative_area_level_1 &&
                            <span>{` ${address.administrative_area_level_1}`}</span>}
                            {address.postal_code && <span>{` ${address.postal_code}`}</span>}
                            {address.country && <span>{` ${address.country}`}</span>}</p>
                      </div>
                      }
                    </p>

                    <div style={{display:'flex'}}>
                      {user.AppUser.PhoneNo ? <span className="phone-text-overview">
                        Ph:{this.displayPhoneNo(user.AppUser.PhoneNo)}
                      </span>
                      : ''}
                      <div className="edit-btn-account" style={(this.state.isLoading)?{pointerEvents:'none'}:{}}><a onClick={this.handleOpen}>&nbsp;Edit</a></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            {user.IsBillable && <div className="col-md-6 col-sm-12 col-xs-12 detail-box">
                <div className="col-md-12 col-xs-12 col-sm-12 detail pull-left">
                  <div className="account-header">Plan Details</div>
                  <div className="account-seperator"/>
                  <div className="text-box">
                    <p><span>Your Plan: </span>{accountDetail.PlanName}</p>
                  </div>
                  <div className="reactive-cancel-btn" style={(this.state.isLoading)?{pointerEvents:'none'}:{}}><a onClick={this.cancelPlan} id={user.IsPlanCanceled ||  this.state.isplanCancel?"Reactive":"Cancel"}>{(user.IsPlanCanceled || this.state.isplanCancel)?"Reactivate Plan":"Cancel Plan"}</a></div>
                </div>
                <div className="col-md-12 col-xs-12 col-sm-12 payment-detail">
                  <div className="col-md-12 payment">
                    <div className="row">
                      <div className="account-header">Payment details</div>
                      <div className="account-seperator"/>
                      <div className="text-box">
                        <p><span>Next Bill Date: </span> {(accountDetail.NextPaymentDate!==null) ? moment(moment(accountDetail.NextPaymentDate).utc().toDate()).local().format('MMMM DD, YYYY') : ''}</p>
                        <p><span>Payment Method: </span>
                          {
                            (accountDetail.PaymentMethod==='CREDITCARD')?
                              accountDetail.CreditcardCompany
                              :
                              (accountDetail.PaymentMethod==='PAYPALBUTTON')&&
                              'PAYPAL'
                          }
                        </p>
                      </div>
                      {!Boolean(user.IsPlanCanceled || this.state.isplanCancel) &&<div style={(this.state.isLoading)?{pointerEvents:'none'}:{}}><a onClick={this.handleEditPayment}>Edit Payment Detail</a></div>}
                    </div>
                  </div>
                  <div className="col-md-12">
                    {accountDetail.TransactionDates && accountDetail.TransactionDates.length > 0 && <div className="row">
                      <div className="history">
                        <div className="account-header">Billing History</div>
                        <div className="account-seperator"/>
                        <ul>
                          {
                            accountDetail.TransactionDates.map((history)=>{
                              return(
                                <li>
                                  <a onClick={()=>this.getTransactionData(accountDetail.PlanName,history.TransctionID)} media="print">
                                    {moment(moment(history.TransactionDate).utc().toDate()).local().format('MMMM DD, YYYY')} Invoice
                                  </a>
                                </li>
                              )
                            })
                          }
                        </ul>
                      </div>
                    </div>}
                  </div>
                </div>
            </div>}

        </div>
      </React.Fragment>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.loginResponse.results,
    businessProfile: state.businessProfile,
    accountDetail:state.accountDetail
  }
};
const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({
    GetBusinessProfile,
    cancelPlanAction,
    enableLoading,
    disableLoading,
    getAccountDetailAction,
    getTransactionDetailAction,
    enableLoader,
    disableLoader,
    editPaymentDetails,
    updateProfileBio
  }, dispatch);
};
export default withStyles(styles)(connect(mapStateToProps, matchDispatchToProps)(AccountDetail));